import React from 'react'
import { Button } from './Button'
import './HeroSection.css';
import '../App.css';
import video from '../videos/video-2.mp4';

function HeroSection() {
  return (
    <div className='hero-container'>
      <video src={video} autoPlay loop muted />
      <h1>Hello, I'm Jef</h1>
      <p>Game Developer and UX/UI freelancer</p>
      {/*
      <div className="hero-btns">
        <Button 
          className="btns" 
          buttonStyle='btn--outline' 
          buttonSize='btn--large'
        >
          Get your design
        </Button>
        <Button 
          className="btns" 
          buttonStyle='btn--primary' 
          buttonSize='btn--large'
        >
          Have a tour <i className='far fa-play-circle' />
        </Button>
      </div>
      */}
    </div>
  )
}

export default HeroSection
